import React, {Component} from 'react'
import { Segment, Button, Divider, Message, Grid } from 'semantic-ui-react'
import LookupVehicle from '../../components/buAddVehicle/LookupVehicle'
import ConfirmVehicle from '../../components/buAddVehicle/ConfirmVehicle'
import VehicleDetails from '../../components/buAddVehicle/VehicleDetails'
import { signup } from '../../modules/auth'
import { Link } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { onLookupVehicleDetails, onStartNewLookup, onAddNewVehicle } from '../../modules/vehicles/buAddVehicle'

class AddVehicle extends Component {

    doLookupVehicle = (vrm) => {
      this.props.onLookupVehicleDetails(vrm);
    }

    doConfirmVehicle = () => {
      const {onAddNewVehicle, vrm} = this.props;
      onAddNewVehicle(vrm)
    }

    doResetLookup = () => {
      this.props.onStartNewLookup();
    }

    componentWillMount() {
      this.props.onStartNewLookup();
    }

    render() {
        const { vrm, vehicleDetails, lookingUpVehicleDetails, addingVehicle, lookupVehicleDetailsError, addVehicleError, hideBackLink } = this.props;
        const pristine = !vrm;
        const vehicleDetailsNotFound = vrm && !vehicleDetails && !lookupVehicleDetailsError;
        const Confirm = (props) => vehicleDetails ? <ConfirmVehicle {...props}/> : null;

        return (
          <div>
              <Grid columns={1} >
              <Grid.Column width={12}>

              {addVehicleError ? <Message error header='We had a problem adding your vehicle' content={addVehicleError} size='tiny'/> : null}
              <h6>Registration number*</h6>
              <LookupVehicle onLookup={this.doLookupVehicle} fetching={lookingUpVehicleDetails} disabled={!pristine && vehicleDetails ? true: false}/>
              <p className="bu-fonts small">Enter your registration number to help us find your vehicle </p>
              {!pristine && !lookingUpVehicleDetails ? [
                <VehicleDetails key={1} data={vehicleDetails} notFound={vehicleDetailsNotFound} error={lookupVehicleDetailsError}/>,
                <Confirm key={2} confirming={addingVehicle} onConfirm={this.doConfirmVehicle} onCancel={this.doResetLookup}/>
                ]: <div> <br/> <br/> <br/> </div>
              }
              {!hideBackLink ? <Segment basic textAlign='center'><p>Back to <Link to="/bournemouth-university/dashboard">your dashboard</Link></p></Segment> : null}
          
          
          </Grid.Column>
          </Grid>
          </div>
        );
    }
}

const mapStateToProps = state => (
  {...state.addVehicle}
)

const mapDispatchToProps = dispatch => bindActionCreators({
  onStartNewLookup,
  onLookupVehicleDetails,
  onAddNewVehicle
}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddVehicle)
